







































































































import { Component, Vue } from "vue-property-decorator";
import { authGuard } from "../auth/authGuard";
import { ReportService } from "../services/reportService";
import ConfirmDeleteDialog from "../components/customActions/ConfirmDeleteDialog.vue";
import ScriptBuilder from "./ScriptBuilder.vue";
import { Report, ReportHeader } from "../interfaces/report";
import { DateService } from "@/services/dateService";

@Component({
    beforeRouteEnter: authGuard,
    components: { ConfirmDeleteDialog, ScriptBuilder },
})
export default class ReportManager extends Vue {
    public selected: [] = [];
    public items: ReportHeader[] = [];
    public deleteDialogActive: boolean = false;
    public idToDelete?: { id: string; index: number };
    public token: string = "";
    public loadedReport: Report | null = null;
    public reportsLoading: boolean = true;

    public async mounted() {
        if (this.$auth.isAuthenticated) {
            this.token = await this.$auth.getTokenSilently();
            this.items = await ReportService.getReports(this.token);
            this.reportsLoading = false;
        }
    }

    public dateParse(date: Date) {
        return DateService.dateParse(date);
    }

    public startDeleting(id: string, index: number) {
        this.idToDelete = { id: id, index: index };
        this.deleteDialogActive = true;
    }
    public deleteReport(confirm: boolean) {
        if (confirm && this.idToDelete) {
            ReportService.deleteReport(this.idToDelete.id, this.token);
            this.items.splice(this.idToDelete.index, 1);
        }
        this.deleteDialogActive = false;
    }
    public async openReport(item: ReportHeader) {
        const singleReport = await ReportService.getReport(item.id, this.token);
        this.loadedReport = singleReport;
    }
    public async download(item: ReportHeader) {
        this.$store.commit("showSnackbar", {
            text: this.$t("report.downloadStarted") as string,
            color: "success",
        });
        const singleReport = await ReportService.getReport(item.id, this.token);
        const payload = JSON.stringify(
            {
                reportData: singleReport.reportData,
                studioData: singleReport.studioData,
            },
            undefined,
            4
        );
        const filelink = ReportService.downloadJSON(payload, item.name);
        filelink.click();
    }
}
